import React, { useState, useRef, useEffect } from 'react';
import defaultClasses from './configuratorGroupTitle.module.css';
import { useStyle } from '../lib/util/classify';
import { Edit2 as EditIcon } from 'react-feather';

const EditableTitle = props => {
    const { initialTitle, onSave } = props;
    const classes = useStyle(defaultClasses, props.classes);
    const [isEditing, setIsEditing] = useState(false);
    const [title, setTitle] = useState(initialTitle);
    const inputRef = useRef();

    useEffect(() => {
        if (isEditing && inputRef.current) {
            inputRef.current.focus();
        }
    }, [isEditing]);

    const handleEditToggle = e => {
        e.preventDefault();
        setIsEditing(!isEditing);
    };

    const handleTitleChange = e => {
        setTitle(e.target.value);
    };

    const handleSave = () => {
        setIsEditing(false);
        if (onSave) {
            onSave(title, initialTitle);
        }
    };

    const handleKeyDown = e => {
        if (e.key === 'Enter') {
            handleSave();
        } else if (e.key === 'Escape') {
            setIsEditing(false);
            setTitle(initialTitle);
        }
    };

    return (
        <div className={classes.root}>
            {isEditing ? (
                <input
                    ref={inputRef}
                    type="text"
                    value={title}
                    onChange={handleTitleChange}
                    onBlur={handleSave}
                    onKeyDown={handleKeyDown}
                    className={classes.input}
                    aria-label={_('Edit title')}
                />
            ) : (
                <h2
                    className={classes.title}
                    onClick={() => setIsEditing(true)}
                >
                    {title}
                </h2>
            )}
            <button
                onClick={handleEditToggle}
                aria-label={isEditing ? _('Save title') : _('Edit title')}
            >
                <EditIcon className={classes.icon} />
            </button>
        </div>
    );
};

export default EditableTitle;
